<template>
  <div v-if="loading" style="height: 100vh; width: 100vw;">
    <div style="display: flex; height: 100%;  align-items: center;justify-content: center">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
  </div>
  <v-app v-else>
    <v-content className="fill-height">
      <v-container>
        <router-view/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import configService from "@/services/configService";

export default {
  name: 'App',
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    const init = async () => {
      const configs = await configService.getConfigs()
      this.setFlagConfigs(configs)
    }

    init().then(() => {
      this.setBrandingConfigs();
      this.setCorrectFavicon();

      this.loading = false;
    });
  },
  methods: {
    ...mapActions([
      'setFlagConfigs',
      'setVaultImagePath'
    ]),
    setCorrectFavicon() {
      // Assign a constant variable and get them by the favicon Id
      const favicon = document.getElementById("favicon");
      const branding = localStorage.getItem('branding') || 'jimber';
      const target = require(`../public/${branding}.png`);
      favicon.setAttribute("href", target);
    },
    setBrandingConfigs() {
    // todo: rework this???
      let branding = 'truncus';
      const referrer = document.referrer;

      console.log('Referrer')
      console.log(referrer)

      if (referrer === '' || referrer == null) {
        console.log("Branding")
        console.log(branding)
        localStorage.setItem('branding', branding)
      } else {
        branding = this.retrieveDns;
        localStorage.setItem('branding', branding)
      }

      const imagePath = require(`./assets/${branding}-vault.png`)
      this.setVaultImagePath(imagePath);
    }
  },
  computed: {
    retrieveDns() {
      const finalData = JSON.parse(this.flagConfigs['branding'])
      const dns = document.referrer.split('//')[1].split('/')[0]

console.log("final data")
    console.log(finalData)

      if (dns === null || dns === '') {
        return 'jimber'
      }

      const b = finalData[dns];
      if(b === undefined) {
        return 'jimber'
      }

      return finalData[dns]
    },
    ...mapGetters([
      'flagConfigs',
    ]),
  },
}
</script>
